import React from 'react';
import * as styles from '../styles/notificationStyles';
import * as TypeStyle from 'typestyle';

export const loadingNotificationCount = 3;

function notificationSkeleton(key: number) {
    return (
        <div key={key} role='row' className='loadingNotification' style={styles.notificationItemRow}>
            <div role='gridcell' className={styles.notificationItemDisabled}>
                <div className={TypeStyle.classes(styles.loadingNotificationContainer)}>
                    <div style={styles.profileContainer}>
                        <div className='loadingProfileImage' style={styles.profileImageContainer}>
                            <div className={TypeStyle.classes(styles.loadingProfilePicture, styles.animate)}></div>
                        </div>
                    </div>
                    <div style={styles.notificationContentContainer}>
                        <div className='loadingHeader' style={styles.contentHeader}>
                            <div className={TypeStyle.classes(styles.loadingHeader, styles.animate)}></div>
                        </div>
                        <div className='loadingText' style={styles.notificationTitle}>
                            <div className={TypeStyle.classes(styles.loadingText, styles.animate)}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function NotificationLoader() {
    let loadingRows = [];
    for (var i = 0; i < loadingNotificationCount; i++) {
        loadingRows.push(notificationSkeleton(i));
    }
    return <div role={'grid'}>{loadingRows}</div>;
}
